import { SpecialityDTO } from "./Speciality.model";
import { ProcedureDTO } from "./Procedure.model";

export class SurgeonDTO {
    SurgeonId: string;
    Name: string;
    Email: string;
    MobileNumber: string;
    ImagePath: string;
    ImageBase64: string;
    Notes: Array<SurgeonNotesDTO>;
    SurgeonSpecialities: Array<SurgeonSpecialityDTO>;
}


export class SurgeonNotesDTO {
    SurgeonId: string;
    NoteId:string;
    Note: string;
    AddedAt: Date;
    ImagePath: string;
    ImageBase64: string;
}


export class SurgeonSpecialityDTO {
    SpecialityID: number;
    SpecialityName: string;
    ProcedureNames: Array<string>;
}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/Models/Surgeon.model.ts